import React from 'react';

const SidebarArrowBgIcon: React.FC<{ className: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="80"
    viewBox="0 0 24 80"
    fill="none"
    className={className}
  >
    <path
      d="M9.5 9.5C9.5 4.25329 5.24671 0 0 0C0.000886917 13.4352 0.00132179 53 0 80C5.24671 80 9.5 75.7467 9.5 70.5V66.5648C9.5 63.0016 10.9155 59.5843 13.4351 57.0648L19.1861 51.3137C25.4345 45.0653 25.4345 34.9347 19.1861 28.6863L13.4351 22.9352C10.9155 20.4157 9.5 16.9984 9.5 13.4352V9.5Z"
      fill="#00155A"
    />
  </svg>
);

export default SidebarArrowBgIcon;
